import React, { useEffect, useState } from "react";
import ModalComponent from "./Modals";
import { Typography, Box } from "@mui/material";
import userLogo from '../../assets/images/user.svg';
import agnetLogo from '../../assets/images/agent.svg'

const ConversationDetailModal = ({ conversations, setShowConversationModal, showConversationModal, selectedCall, modalType }: any) => {
    const [conversationData, setConversationData] = useState<any[]>([]);

    useEffect(() => {
        if (conversations && conversations.data && conversations.data.conversations) {
            setConversationData(conversations.data.conversations);
        }
    }, [conversations]);

    const handleCloseConversationModal = () => { 
        setShowConversationModal(false);
    };

    return (
        <ModalComponent
        isOpen={showConversationModal}
        onClose={handleCloseConversationModal}
        modalHeading={"Conversation Details"}
        size="lg"
        callAttachment={selectedCall?.data?.callAttachment}
            modalType={modalType}
    >
        <div className="modal-content overflow-x-hidden mt-2">
            {conversationData.length > 0 ? (
                conversationData.map((conversation: any, index: number) => (
                    <Box key={index} className={`message ${conversation.speakerType}`}>
                        <div className="row align-items-center justify-content-between px-2">
                            <div className="col-auto">
                                <Typography variant="body2" className="speaker-type">
                                    {conversation.speakerType === "user" ? (
                                        <>
                                            User
                                            <img src={userLogo} className="cs-img"/>
                                        </>
                                    ) : (
                                        <>
                                            Agent
                                           <img src={agnetLogo} className="cs-img"/>
                                        </>
                                    )}
                                </Typography>
                            </div>
                            <div className="col-auto">
                                <Typography
                                    variant="caption"
                                    className={conversation.speakerType === "user" ? "timestamp" : "timestamp-agent"}>
                                    {new Date(conversation.updatedAt).toLocaleString()}
                                </Typography>
                            </div>
                        </div>
                        <Typography
                            variant="body1"
                            className={conversation.speakerType === "user" ? "user-message" : "agent-message"}>
                            {conversation.content}
                        </Typography>
                    </Box>
                ))
            ) : (
                <Typography variant="body1" className="no-conversation">
                    No conversation data available.
                </Typography>
            )}
        </div>
    </ModalComponent>
    );
};

export default ConversationDetailModal;
